// Copyright 2019, White Label Communications, LLC, All rights reserved.

import React from 'react';
import PropTypes from 'prop-types';
import equal from 'deep-equal';
import {
  Container,
  Row,
  Col,
  Button,
  Form,
} from 'react-bootstrap';

import Select from 'react-select';

import Layout from 'components/Layout/Layout';
import DashBoard from 'components/Layout/Dashboard';
import SuccessAlert from 'components/Common/Alerts/Success';
import ErrorAlert from 'components/Common/Alerts/Error';
import Settings from 'images/settings.svg';

const fileretentionOptions = [
  {
    label: 'Keep all files forever',
    value: 0,
  },
  {
    label: 'Keep all files, but only for a set duration',
    value: 1,
  },
];
const fileretentionDeleteOptions = [
  {
    label: "Users can't delete files",
    value: 0,
  },
  {
    label: 'Users can mark files deleted and they will be removed after',
    value: 1,
  },
];

const fileretentiontDuration = [
  {
    label: 'Days',
    value: 'd',
  },
  {
    label: 'Months',
    value: 'm',
  },
  {
    label: 'Years',
    value: 'y',
  },
];

class FileRetention extends React.PureComponent {
  constructor(props) {
    super(props);
    const { fileRetentionData } = this.props;
    // console.log('constructor', fileRetentionData); // eslint-disable-line no-console
    let fileRetenionPeriodObj = { label: 'Days', value: 'd' };
    let fileRetenionValueObj = { label: 'Keep all files forever', value: 0 };
    let userActionPeriodObj = { label: 'Days', value: 'd' };
    let userActionValueObj = { label: "Users can't delete messages", value: 0 };
    let fileRetentionCount = 0;
    let userActionCount = 0;
    if (fileRetentionData.file_retention) {
      fileRetenionValueObj = fileretentionOptions
        .find((option) => option.value === fileRetentionData.file_retention.value);
      fileRetenionPeriodObj = fileretentiontDuration
        .find((option) => option.value === fileRetentionData.file_retention.duration.period);
      fileRetentionCount = fileRetentionData.file_retention.duration.count;
    }
    if (fileRetentionData.user_actions) {
      userActionValueObj = fileretentionDeleteOptions
        .find((option) => option.value === fileRetentionData.user_actions.value);
      userActionPeriodObj = fileretentiontDuration
        .find((option) => option.value === fileRetentionData.user_actions.duration.period);
      userActionCount = fileRetentionData.user_actions.duration.count;
    }
    this.state = {
      successAlert: '',
      errorAlert: '',
      fileRetentionData,
      fileRetention: {
        file_retention: {
          value: fileRetenionValueObj,
          duration: {
            count: fileRetentionCount,
            period: fileRetenionPeriodObj,
          },
        },
        user_actions: {
          value: userActionValueObj,
          duration: {
            count: userActionCount,
            period: userActionPeriodObj,
          },
        },
      },
    };
  }

  static getDerivedStateFromProps(props, state) {
    // Any time props value changes set the current state accordingly
    if (!equal(props.fileRetentionData, state.fileRetentionData)) {
      const { fileRetentionData } = props;
      let fileRetenionPeriodObj = null;
      let fileRetenionValueObj = null;
      let userActionPeriodObj = null;
      let userActionValueObj = null;
      let fileRetentionCount = 0;
      let userActionCount = 0;
      if (fileRetentionData.file_retention) {
        fileRetenionValueObj = fileretentionOptions
          .find((option) => option.value === fileRetentionData.file_retention.value);
        fileRetenionPeriodObj = fileretentiontDuration
          .find((option) => option.value === fileRetentionData.file_retention.duration.period);
        fileRetentionCount = fileRetentionData.file_retention.duration.count;
      }
      if (fileRetentionData.user_actions) {
        userActionValueObj = fileretentionDeleteOptions
          .find((option) => option.value === fileRetentionData.user_actions.value);
        userActionPeriodObj = fileretentiontDuration
          .find((option) => option.value === fileRetentionData.user_actions.duration.period);
        userActionCount = fileRetentionData.user_actions.duration.count;
      }
      const newState = {
        fileRetentionData,
        fileRetention: {
          file_retention: {
            value: fileRetenionValueObj,
            duration: {
              count: fileRetentionCount,
              period: fileRetenionPeriodObj,
            },
          },
          user_actions: {
            value: userActionValueObj,
            duration: {
              count: userActionCount,
              period: userActionPeriodObj,
            },
          },
        },
      };
      // console.log('newState: ', newState);
      return newState;
    }
    return null;
  }

  componentDidMount = () => {
    const { fetchFileRetention, currentTeam } = this.props;
    fetchFileRetention(currentTeam.currentTeamId); // get initial file retention values
  }

  componentDidUpdate(prevProps) {
    const { uiFileRetention } = this.props;
    if (prevProps.uiFileRetention.post.status === 1 && uiFileRetention.post.status === 2) {
      this.setAlerts('', uiFileRetention.post.error);
    }
    if (prevProps.uiFileRetention.post.status === 1 && uiFileRetention.post.status === 3) {
      this.setAlerts('Settings Saved Successfully', '');
    }
  }

  setAlerts = (successAlert, errorAlert) => {
    this.setState({
      successAlert,
      errorAlert,
    });
  }

  onAlertDismissed = (alertType) => {
    this.setState({
      [alertType]: '',
    });
  }

  changeValue = (selectedValue, action) => {
    const splittedNameArr = action.name.split('-');
    const channelName = splittedNameArr[0];
    const name = splittedNameArr[1];
    this.setState(
      (prevState) => ({
        ...prevState,
        fileRetention: {
          ...prevState.fileRetention,
          [channelName]: {
            ...prevState.fileRetention[channelName],
            [name]: selectedValue,
          },
        },
      }),
    );
  }

  onInputChange = (e) => {
    const { name, value } = e.target;
    const splittedNameArr = name.split('-');
    const channelName = splittedNameArr[0];
    const inputName = splittedNameArr[1];
    this.setState(
      (prevState) => ({
        fileRetention: {
          ...prevState.fileRetention,
          [channelName]: {
            ...prevState.fileRetention[channelName],
            duration: {
              ...prevState.fileRetention[channelName].duration,
              [inputName]: value,
            },
          },
        },
      }),
    );
  }

  changePeriod = (selectedValue, action) => {
    const splittedNameArr = action.name.split('-');
    const channelName = splittedNameArr[0];
    const name = splittedNameArr[1];
    this.setState(
      (prevState) => ({
        ...prevState,
        fileRetention: {
          ...prevState.fileRetention,
          [channelName]: {
            ...prevState.fileRetention[channelName],
            duration: {
              ...prevState.fileRetention[channelName].duration,
              [name]: selectedValue,
            },
          },
        },
      }),
    );
  }

  submitForm = (e) => {
    e.preventDefault();
    this.setState({
      successAlert: '',
      errorAlert: '',
    });
    const { postFileRetention, currentTeam } = this.props;
    const { fileRetention } = this.state;
    const fileRetentionSaveObj = { file_retention: {}, user_actions: {} };
    fileRetentionSaveObj.file_retention.value = fileRetention.file_retention.value.value;
    fileRetentionSaveObj.file_retention.duration = {
      count: parseInt(fileRetention.file_retention.duration.count, 10),
      period: fileRetention.file_retention.duration.period.value,
    };
    fileRetentionSaveObj.user_actions.value = fileRetention.user_actions.value.value;
    fileRetentionSaveObj.user_actions.duration = {
      count: parseInt(fileRetention.user_actions.duration.count, 10),
      period: fileRetention.user_actions.duration.period.value,
    };


    /* fileRetentionSaveObj.value = fileRetention.value.value;
    fileRetentionSaveObj.duration = {
      count: parseInt(fileRetention.duration.count, 10),
      period: fileRetention.duration.period.value,
    }; */
    // console.log('fileRetentionSaveObj: ', fileRetentionSaveObj);
    postFileRetention(currentTeam.currentTeamId, fileRetentionSaveObj); // save file retention values
    // const { fileRetention } = this.state;
  }

  render() {
    const {
      fileRetention,
      successAlert,
      errorAlert,
    } = this.state;
    return (
      <Layout>
        <DashBoard>
          <div className="space-settings">
            <div className="title-section">
              <h2>
                <img src={Settings} alt="boomea" />
                TEAM SETTINGS
              </h2>
            </div>
            <Container fluid>
              <Row>
                <Col md={{ offset: 0, span: 12 }}>
                  <div className="manage-users-table">
                    <div className="space-header">
                      <Container fluid>
                        <Row>
                          <Col md={12}>FILE RETENTION</Col>
                        </Row>
                      </Container>
                    </div>
                    <div className="manage-area retention">
                      <ErrorAlert
                        error={errorAlert}
                        onAlertDismissed={this.onAlertDismissed}
                        alertType="errorAlert"
                      />
                      <SuccessAlert
                        success={successAlert}
                        onAlertDismissed={this.onAlertDismissed}
                        alertType="successAlert"
                      />
                      <Container fluid>
                        <Form onSubmit={this.submitForm}>
                          <Row>
                            <Col md={7}>
                              <Form.Group controlId="retention-select">
                                <Form.Label>File Retention:</Form.Label>
                                <Select
                                  options={fileretentionOptions}
                                  value={(fileRetention
                                    && fileRetention.file_retention
                                    && fileRetention.file_retention.value)
                                    ? fileRetention.file_retention.value
                                    : null}
                                  className="select-container"
                                  name="file_retention-value"
                                  onChange={this.changeValue}
                                  required
                                />
                              </Form.Group>
                            </Col>

                            {(fileRetention
                            && fileRetention.file_retention
                            && fileRetention.file_retention.value
                            && fileRetention.file_retention.value.value)
                              ? (
                                <Col md={5}>
                                  <Form.Group controlId="retention-duration">
                                    <Form.Label>Duration:</Form.Label>
                                    <input
                                      type="number"
                                      value={(fileRetention
                                        && fileRetention.file_retention
                                        && fileRetention.file_retention.duration
                                        && fileRetention.file_retention.duration.count)
                                        ? fileRetention.file_retention.duration.count
                                        : ''}
                                      className="select-container days-count"
                                      onChange={this.onInputChange}
                                      name="file_retention-count"
                                      min="1"
                                      max="999"
                                      required
                                    />

                                    <Select
                                      options={fileretentiontDuration}
                                      value={(fileRetention
                                        && fileRetention.file_retention
                                        && fileRetention.file_retention.duration
                                        && fileRetention.file_retention.duration.period)
                                        ? fileRetention.file_retention.duration.period
                                        : null}
                                      className="select-container days-type"
                                      onChange={this.changePeriod}
                                      name="file_retention-period"
                                      required
                                    />
                                  </Form.Group>
                                </Col>
                              ) : null }

                            <Col md={7}>
                              <Form.Group controlId="retention-select-delete">
                                <Form.Label>User Actions:</Form.Label>
                                <Select
                                  options={fileretentionDeleteOptions}
                                  value={
                                    (fileRetention
                                      && fileRetention.user_actions
                                      && fileRetention.user_actions.value
                                    )
                                      ? fileRetention.user_actions.value
                                      : null
                                  }
                                  className="select-container"
                                  name="user_actions-value"
                                  onChange={this.changeValue}
                                  required
                                />
                              </Form.Group>
                            </Col>
                            {(fileRetention
                            && fileRetention.user_actions
                            && fileRetention.user_actions.value
                            && fileRetention.user_actions.value.value)
                              ? (
                                <Col md={5}>
                                  <Form.Group controlId="retention-duration">
                                    <Form.Label>Duration:</Form.Label>
                                    <input
                                      type="number"
                                      value={(fileRetention
                                        && fileRetention.user_actions
                                        && fileRetention.user_actions.duration
                                        && fileRetention.user_actions.duration.count)
                                        ? fileRetention.user_actions.duration.count
                                        : ''}
                                      className="select-container days-count"
                                      onChange={this.onInputChange}
                                      name="user_actions-count"
                                      min="1"
                                      max="999"
                                      required
                                    />

                                    <Select
                                      options={fileretentiontDuration}
                                      value={(fileRetention
                                        && fileRetention.user_actions
                                        && fileRetention.user_actions.duration
                                        && fileRetention.user_actions.duration.period)
                                        ? fileRetention.user_actions.duration.period
                                        : null}
                                      className="select-container days-type"
                                      onChange={this.changePeriod}
                                      name="user_actions-period"
                                      required
                                    />
                                  </Form.Group>
                                </Col>
                              ) : null }
                          </Row>

                          <div className="line-sep" />
                          <Row>
                            <Col md={12}>
                              <div className="retention-message">
                                <Form.Group controlId="retention-duration">
                                  <Form.Label>Note:</Form.Label>
                                  By default, Boomea keeps all your files for the lifetime of your team.
                                  If you&apos;d like, you can have them deleted after a set amount of time.
                                  Note that this affects all files — including images, docs, files in Boomea posts and more
                                </Form.Group>
                              </div>
                            </Col>
                            <Col md={12}>
                              <Button type="submit" variant="blue">SAVE CHANGES</Button>
                            </Col>
                          </Row>
                        </Form>
                      </Container>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </DashBoard>
      </Layout>
    );
  }
}

FileRetention.propTypes = {
  fetchFileRetention: PropTypes.func.isRequired,
  postFileRetention: PropTypes.func.isRequired,
  fileRetentionData: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string),
      PropTypes.objectOf(
        PropTypes.oneOfType([
          PropTypes.number,
          PropTypes.string,
        ]),
      ),
    ]),
  ),
  currentTeam: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  ).isRequired,
  uiFileRetention: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string),
      PropTypes.objectOf(
        PropTypes.oneOfType([
          PropTypes.number,
          PropTypes.string,
        ]),
      ),
    ]),
  ).isRequired,
};

FileRetention.defaultProps = {
  fileRetentionData: {},
};

export default FileRetention;
